import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetSystemsLookupResponse } from "../../../common/api/orders-api/system/GetSystemsLookupResponse";
import { useSystemApi } from "../../../common/api/orders-api/system/useSystemApi";
import { mapToSystem, System } from "../../../common/types/System";

interface ISystemsDataContext {
    systems: System[];
    isLoading: boolean;
}

export const SystemsDataContext = createContext<ISystemsDataContext>({
    systems: [],
    isLoading: true
});

type SystemsDataProviderProps = React.PropsWithChildren<unknown>;

export const SystemsDataProvider: React.FunctionComponent<SystemsDataProviderProps> = ({
    children
}: SystemsDataProviderProps) => {
    const [systems, setSystems] = useState<System[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getSystemsLookup } = useSystemApi();

    useEffect(() => {
        setIsLoading(true);

        getSystemsLookup()
            .then((response: GetSystemsLookupResponse) => {
                const mappedItems = response.items.map(mapToSystem);
                const sortedItems = getSortedCollection(mappedItems, "name");

                setSystems(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return <SystemsDataContext.Provider value={{ systems, isLoading }}>{children}</SystemsDataContext.Provider>;
};
